import { render, staticRenderFns } from "./CommunalRatesView.vue?vue&type=template&id=61f79e93"
import script from "./CommunalRatesView.vue?vue&type=script&lang=js"
export * from "./CommunalRatesView.vue?vue&type=script&lang=js"
import style0 from "./CommunalRatesView.vue?vue&type=style&index=0&id=61f79e93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports